import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  WindowPreset,
  DateWindow,
  getPresetRange,
} from '../../utils/dateWindow';

export interface PmDashboardFilters {
  preset: WindowPreset;
  range: DateWindow;
  projectId?: string;
  phaseId?: string;
  blockId?: string;
  buildingId?: string;
  unitId?: string;
  teamId?: string;
  status?: string;
  criticalOnly?: boolean;
}

interface PmDashboardState {
  filters: PmDashboardFilters;
}

const initialPreset: WindowPreset = 'NEXT_2_WEEKS';

const initialState: PmDashboardState = {
  filters: {
    preset: initialPreset,
    range: getPresetRange(initialPreset),
    criticalOnly: false,
  },
};

const pmDashboardSlice = createSlice({
  name: 'pmDashboard',
  initialState,
  reducers: {
    setPreset(state, action: PayloadAction<WindowPreset>) {
      state.filters.preset = action.payload;
      if (action.payload !== 'CUSTOM') {
        state.filters.range = getPresetRange(action.payload);
      }
    },
    setCustomRange(state, action: PayloadAction<DateWindow>) {
      state.filters.preset = 'CUSTOM';
      state.filters.range = action.payload;
    },
    setScope(
      state,
      action: PayloadAction<Partial<Pick<PmDashboardFilters,
        'projectId' | 'phaseId' | 'blockId' | 'buildingId' | 'unitId' | 'teamId' | 'status' | 'criticalOnly'>>>
    ) {
      state.filters = { ...state.filters, ...action.payload };
    },
    resetFilters(state) {
      state.filters = {
        preset: initialPreset,
        range: getPresetRange(initialPreset),
        criticalOnly: false,
      };
    },
  },
});

export const { setPreset, setCustomRange, setScope, resetFilters } =
  pmDashboardSlice.actions;
export default pmDashboardSlice.reducer;
